import { createAction, props } from '@ngrx/store';
import { MitarbeiterItem } from '../../mitarbeiter.model';
import {RolleItem} from '../../rolle.model';

export const deleteRolleStart = createAction('MITARBEITERVERWALTUNG::DELETE_ROLLE_START', props<{ item: RolleItem }>());
export const deleteRolleSucceeded = createAction(
    'MITARBEITERVERWALTUNG::DELETE_ROLLE_SUCCEEDED',
  props<{item: RolleItem}>()
);
export const deleteRolleFailed = createAction('MITARBEITERVERWALTUNG::DELETE_ROLLE_FAILED', props<{ error: string }>());
